<template>
  
    <div id="header">

        <div class="container">

            <div class="row">

                <div class="col-10 header-component">

                    <app-header-text></app-header-text>        
        
                </div>

                <div class="col-2 header-component">

                    <app-header-language></app-header-language>

                </div>

            </div>

        </div>

    </div>

</template>

<script>
import HeaderText from './HeaderText.vue'
import HeaderLanguage from './HeaderLanguage'

export default {
  name: 'App',
  components: {
    appHeaderText: HeaderText,
    appHeaderLanguage: HeaderLanguage,
  }
}
</script>

<style>

#header {
    width: 100%;
}

.header-component {
    width: 100%;

    padding: 2rem;

    display: flex;
    align-items: center;
    justify-content: center;
}

</style>